import { render, staticRenderFns } from "./Avv.vue?vue&type=template&id=2e8e9c50&scoped=true&"
import script from "./Avv.vue?vue&type=script&lang=js&"
export * from "./Avv.vue?vue&type=script&lang=js&"
import style0 from "./Avv.vue?vue&type=style&index=0&id=2e8e9c50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8e9c50",
  null
  
)

export default component.exports